import type { AspectRatioProps } from '@chakra-ui/react';
import { AspectRatio, Box } from '@chakra-ui/react';
import { RecommendedMarquee } from '@time-line/components/common';

import { DiscountBadge } from '../DiscountBadge';
import type { DiscountBadgeData } from '../types';

export const ProductGalleryDesktopItemWrapper = ({
  isDoctorRecommended,
  discountBadge,
  children,
  ratio,
  ...props
}: AspectRatioProps & {
  isDoctorRecommended?: boolean;
  discountBadge?: DiscountBadgeData | null;
}) => (
  <Box
    gridColumn="span 1"
    display="grid"
    position="relative"
    _before={{
      zIndex: 1,
      content: '""',
      display: 'block',
      position: 'absolute',
      inset: 0,
      bgColor: 'blackAlpha.50',
      opacity: 0,
      pointerEvents: 'none',
      transitionProperty: 'common',
      transitionDuration: 'fast',
    }}
    _hover={{
      _before: {
        opacity: 1,
      },
    }}
    sx={{
      '> *': {
        gridRow: 1,
        gridColumn: 1,
      },
    }}
  >
    {discountBadge && (
      <DiscountBadge
        price={discountBadge.price}
        compareAtPrice={discountBadge.compareAtPrice}
      />
    )}
    {isDoctorRecommended && (
      <Box
        zIndex={1}
        alignSelf="end"
        position="absolute"
        bottom="2xs"
        width="100%"
        px="4xs"
      >
        <RecommendedMarquee />
      </Box>
    )}
    <AspectRatio
      ratio={ratio}
      borderRadius="base"
      overflow="hidden"
      bgColor="gray.100"
      {...props}
    >
      {children}
    </AspectRatio>
  </Box>
);
